export const GET_COMPETITOR_DATA = 'GET_COMPETITOR_DATA'
export const GET_COMPETITOR_DATA_SUCCESS = 'GET_COMPETITOR_DATA_SUCCESS'